<template>
  <div class="character-prose">
    <text-ref v-if="verse.ref && verse.ref.length > 0" :id="verse.ref" :text="verse.text"/>
    <text-with-refs v-else :text="verse.text"/>
  </div>
</template>
<script>
import TextWithRefs from './TextWithRefs'
import Ref from './Ref'
import TextRef from './TextRef'

export default {
  components: {TextRef, Ref, TextWithRefs},
  props: {
    verse: {type: Object, required: true},
  }
}
</script>
<style lang="scss" scoped>
.character-prose {
  display: flex;
  position: relative;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
